/**
 * Rise — entrada padrão da plataforma: sobe com fade na curva Odisseia.
 * Use `i` para escalonar listas (delay limitado pra caudas longas não
 * demorarem). Enter-only: zero custo na saída, seguro em qualquer lista.
 */
import { motion, useReducedMotion } from 'motion/react';
import type { ReactNode } from 'react';

export function Rise({
  i = 0,
  className,
  children,
}: {
  i?: number;
  className?: string;
  children: ReactNode;
}) {
  const reduce = useReducedMotion();
  return (
    <motion.div
      className={className}
      initial={reduce ? false : { opacity: 0, y: 14 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ delay: Math.min(i, 12) * 0.055, duration: 0.42, ease: [0.22, 1, 0.36, 1] }}
    >
      {children}
    </motion.div>
  );
}
